// A higher order reducer that adds 'loading' to the component's state
// Later this will export a blocking loader thay components can use for async actions
import reducer from './src/reducer';

export default { reducer };
